export default "__VITE_ASSET__8b052f49__"